import React from 'react';
import { Route } from 'react-router';
import ClassifiedAds from './ClassifiedAds';

export default (
  <Route path="moderator">
    <Route path="classified-ads" component={ClassifiedAds} />
  </Route>
);
